/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Tour',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M11.493 6.281a3.03 3.03 0 1 1 0 6.064c-1.675 0-3.032-1.358-3.032-3.032s1.358-3.032 3.032-3.032zm0 1.199c-1.012 0-1.833.821-1.833 1.833s.821 1.833 1.833 1.833 1.833-.821 1.833-1.833-.821-1.833-1.833-1.833zm-5.8-5.042a.6.6 0 0 1 .601.6v.179h10.612a2 2 0 0 1 1.898 2.629l-.939 2.84-.045.154a2 2 0 0 0 .045 1.103l.939 2.84a2 2 0 0 1-1.771 2.625l-.127.004H6.293v5.554a.6.6 0 1 1-1.2 0V3.037a.6.6 0 0 1 .6-.6zm.601 11.773h10.612a.8.8 0 0 0 .76-1.051l-.94-2.841a3.2 3.2 0 0 1 0-2.011l.94-2.841a.8.8 0 0 0-.76-1.051H6.293v9.794z" />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
